import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CMSService } from 'client/services';

const internalMediaPattern = /^(\/media|\/secure-media)(.*)/i;
const isVideo = '(.mpg|.mp2|.mpeg|.mpe|.mpv|.mp4|.webm)$'; // you can add more extention

const MarkdownMediaLoader = ({ src, alt, ...props }) => {
    const [internalMediaSource, setInternalMediaSource] = useState(null);

    useEffect(() => {
        const matches = src.match(internalMediaPattern);
        if (matches) {
            const loadMedia = async (internalUrl) => {
                const mediaResult = await CMSService.getMedia(internalUrl, matches[1] === '/secure-media');
                setInternalMediaSource(mediaResult);
            };

            loadMedia(matches[2]);
        }
    }, [src]);

    const isVideoUrl = src.match(isVideo);
    return isVideoUrl && internalMediaSource
        ? <video data-testid={props['data-testid']} src={internalMediaSource} width="350" controls />
        : internalMediaSource
            ? <img data-testid={props['data-testid']} src={internalMediaSource} alt={alt}/>
            : <img data-testid={props['data-testid']} src={src} alt={alt}/>;
};

MarkdownMediaLoader.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    'data-testid': PropTypes.string
};

export default MarkdownMediaLoader;
